import React, { useState, useRef } from "react";

const Involved = () => {
  const formRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null);
    const apiURL = "https://eq5vlh2hwl.execute-api.us-east-2.amazonaws.com/prod";
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setSubmissionStatus(null);
  
      try {
        const formData = new FormData(formRef.current);
        const formDataObject = {};
        formData.forEach((value, key) => {
          formDataObject[key] = value;
        });
  
        const response = await fetch(apiURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formDataObject),
        });
  
        if (response.ok) {
          setSubmissionStatus("success");
          if (formRef.current) { //added check
            formRef.current.reset();
          }
        } else {
          setSubmissionStatus("error");
        }
      } catch (err) {
        console.error(err);
        setSubmissionStatus("error");
      } finally {
        setLoading(false);
      }
    };
  return (
    <><div className="formImage"><img src="/images/newYorkStateMap.jpg" /></div><div className="involved">
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        name="save-google-sheet"
        id="save-google-sheet"
        className=""
      >
        <div class="status">
          {submissionStatus === 'error' && (
            <p class="error" style={{ color: "red" }}>Form submission failed.</p>
          )}
          <p className="thanks">
            {loading ? "Loading..." : ""}
          </p>
          <p className="thanks">
            {submissionStatus === 'success' ? "Thank you for your interest. I will get back to you as soon as possible." : " "}
          </p>
        </div>
          <h2 className="">Get Involved with OCD NY</h2>
          <div className="fields">
            <div className="comment">
              <textarea id="comment" name="comment" placeholder="How would you like to get involved?" />
            </div>
            <div className="contact-info">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name" />
              <input
                type="phone"
                id="phone"
                name="phone"
                placeholder="Phone Number" />
              <input
                type="email"
                id="email"
                name="email"
                placeholder="E-mail Address" />
            </div>
          </div>
          <div className="submit">
            <input
              className="button"
              type="submit"
              value={loading ? "Loading..." : "Submit"} />
          </div>
        </form>
    </div></>
  );
};

export default Involved;
